import type { DriverType } from '@ria-client/supergraph/marketplace/types';
import type { SummaryTableRowType } from '@ria-client/supergraph/roundup/types';
import { ApyDriver } from './apy-driver';

export interface CdApysDriverProps {
  dividerSpacing?: number;
  driver?: DriverType;
  oneYearApyEntity?: SummaryTableRowType['oneYearApyEntity'];
  threeYearApyEntity?: SummaryTableRowType['threeYearApyEntity'];
  fiveYearApyEntity?: SummaryTableRowType['fiveYearApyEntity'];
}

export function CdApysDriver({
  driver,
  oneYearApyEntity,
  threeYearApyEntity,
  fiveYearApyEntity,
  dividerSpacing = 3,
}: CdApysDriverProps) {
  const apyDrivers = [
    { ...oneYearApyEntity?.driverApy, label: '1-year APY' },
    { ...threeYearApyEntity?.driverApy, label: '3-year APY' },
    { ...fiveYearApyEntity?.driverApy, label: '5-year APY' },
  ].filter(candidate => candidate.id?.includes('apy') && candidate.value);
  const finalDrivers = apyDrivers.length > 0 ? apyDrivers : [driver];
  // ponytail: only legacy-used spacings (2, 3) are emitted so Tailwind generates their classes.
  const dividerSpacingClass = dividerSpacing === 2 ? 'my-2' : 'my-3';

  return (
    <div className="flex flex-col">
      {finalDrivers.map((finalDriver, index) => (
        <div key={`${finalDriver?.id}-${index}`}>
          {index > 0 && <hr className={`${dividerSpacingClass} border-0 border-t border-border`} />}
          {finalDriver?.label && finalDriver.value ? (
            <ApyDriver
              termLength={finalDriver.label}
              termLengthValue={finalDriver.value}
              valueTooltip={finalDriver.valueTooltip}
            />
          ) : (
            <p>N/A</p>
          )}
        </div>
      ))}
    </div>
  );
}
